document.addEventListener('DOMContentLoaded', function () {
  function printSelectedVariant() {
    var selectedVariantDiv = document?.getElementById('selected-variant');

    if (!selectedVariantDiv) {
      return null;
    }
    return selectedVariantDiv.getAttribute('data-title');
  }

  // Get the initial selected variant title
  var currentSelectedTitle = printSelectedVariant();

  // Initial check for the buy button visibility
  // updateBuyButtonVisibility();

  var variantPickers = document.querySelectorAll(
    '.product-form__input input[type="radio"], .product-form__input select'
  );

  variantPickers.forEach(function (picker) {
    picker.addEventListener('change', function () {
      var selectedVariantDiv = document.getElementById('selected-variant');

      var selectedVariantTitle = this.getAttribute('data-title') || this.value;
      selectedVariantDiv.setAttribute('data-title', selectedVariantTitle);

      currentSelectedTitle = selectedVariantTitle;
    });
  });
});
